import React from "react";
import { Tag, Tooltip } from "antd";
import { Product } from "src/models/ProductModel";

interface TagsCellProps {
  tags: Product["offerTags"];
}

const TagsCell: React.FC<TagsCellProps> = ({ tags }) => {
  if (!tags || tags.length === 0) {
    return <span>_</span>;
  }

  const displayedTags = tags.slice(0, 5);
  const remainingTags = tags.slice(5);

  return (
    <div>
      {displayedTags.map((tag) => (
        <Tag key={tag.id}>{tag.tagNameEn}</Tag>
      ))}
      {remainingTags.length > 0 && (
        <Tooltip
          title={
            <div>
              {remainingTags.map((tag) => (
                <Tag key={tag.id}>{tag.tagNameEn}</Tag>
              ))}
            </div>
          }
        >
          <Tag>+{remainingTags.length}</Tag>
        </Tooltip>
      )}
    </div>
  );
};

export default TagsCell;
